var Novedad = (function () {
    function Novedad(sujeto, accion, entId, descr, tipo, status, fecha, objeto) {
        this.sujeto = sujeto;
        this.accion = accion;
        this.entId = entId;
        this.descr = descr;
        this.tipo = tipo;
        this.status = status;
        this.fecha = fecha;
        this.objeto = objeto;
    }
    return Novedad;
}());
export { Novedad };
var NovedadPage = (function () {
    function NovedadPage(page, size, total, data) {
        this.page = page;
        this.size = size;
        this.total = total;
        this.data = data;
    }
    return NovedadPage;
}());
export { NovedadPage };
//# sourceMappingURL=novedad.js.map